import React from 'react';

interface AccessDeniedProps {
  title?: string;
  message?: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({
  title = "Access Restricted",
  message = "You don't have the necessary permissions to view this resource.",
}) => {
  return (
    <div className="flex h-full w-full min-h-[300px] flex-col items-center justify-center p-6 text-center">
      {/* Icon Circle */}
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 mb-4">
        <svg 
          className="h-6 w-6 text-amber-600" 
          fill="none" 
          viewBox="0 0 24 24" 
          strokeWidth="2" 
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
        </svg>
      </div>

      {/* Text Content */}
      <h3 className="text-lg font-semibold text-gray-900">
        {title}
      </h3>
      <p className="mt-1 max-w-xs text-sm text-gray-500">
        {message}
      </p>
    </div>
  );
};

export default AccessDenied;